module.exports = __webpack_public_path__ + "img/img6.a2b7141f.png";